"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstance = exports.init = exports.EppoJSClient = void 0;
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
const local_storage_1 = require("./local-storage");
const local_storage_assignment_cache_1 = require("./local-storage-assignment-cache");
const sdk_data_1 = require("./sdk-data");
const localStorage = new local_storage_1.EppoLocalStorage();
/**
 * Client for assigning experiment variations.
 * @public
 */
class EppoJSClient extends js_client_sdk_common_1.EppoClient {
    getStringAssignment(flagKey, subjectKey, subjectAttributes, defaultValue) {
        EppoJSClient.getAssignmentInitializationCheck();
        return super.getStringAssignment(flagKey, subjectKey, subjectAttributes, defaultValue);
    }
    getBoolAssignment(flagKey, subjectKey, subjectAttributes, defaultValue) {
        EppoJSClient.getAssignmentInitializationCheck();
        return super.getBoolAssignment(flagKey, subjectKey, subjectAttributes, defaultValue);
    }
    getIntegerAssignment(flagKey, subjectKey, subjectAttributes, defaultValue) {
        EppoJSClient.getAssignmentInitializationCheck();
        return super.getIntegerAssignment(flagKey, subjectKey, subjectAttributes, defaultValue);
    }
    getNumericAssignment(flagKey, subjectKey, subjectAttributes, defaultValue) {
        EppoJSClient.getAssignmentInitializationCheck();
        return super.getNumericAssignment(flagKey, subjectKey, subjectAttributes, defaultValue);
    }
    getJSONAssignment(flagKey, subjectKey, subjectAttributes, defaultValue) {
        EppoJSClient.getAssignmentInitializationCheck();
        return super.getJSONAssignment(flagKey, subjectKey, subjectAttributes, defaultValue);
    }
    static getAssignmentInitializationCheck() {
        if (!EppoJSClient.initialized) {
            console.warn('Eppo SDK assignment requested before init() completed');
        }
    }
}
exports.EppoJSClient = EppoJSClient;
EppoJSClient.instance = new EppoJSClient(localStorage, undefined, true);
EppoJSClient.initialized = false;
/**
 * Initializes the Eppo client with configuration parameters.
 * This method should be called once on application startup.
 * @param config - client configuration
 * @public
 */
async function init(config) {
    var _a, _b, _c, _d, _e, _f, _g;
    js_client_sdk_common_1.validation.validateNotBlank(config.apiKey, 'API key required');
    try {
        // If any existing instances; ensure they are not polling
        if (EppoJSClient.instance) {
            EppoJSClient.instance.stopPolling();
        }
        const requestConfiguration = {
            apiKey: config.apiKey,
            sdkName: sdk_data_1.sdkName,
            sdkVersion: sdk_data_1.sdkVersion,
            baseUrl: (_a = config.baseUrl) !== null && _a !== void 0 ? _a : undefined,
            requestTimeoutMs: (_b = config.requestTimeoutMs) !== null && _b !== void 0 ? _b : undefined,
            numInitialRequestRetries: (_c = config.numInitialRequestRetries) !== null && _c !== void 0 ? _c : undefined,
            numPollRequestRetries: (_d = config.numPollRequestRetries) !== null && _d !== void 0 ? _d : undefined,
            pollAfterSuccessfulInitialization: (_e = config.pollAfterSuccessfulInitialization) !== null && _e !== void 0 ? _e : false,
            pollAfterFailedInitialization: (_f = config.pollAfterFailedInitialization) !== null && _f !== void 0 ? _f : false,
            throwOnFailedInitialization: true, // always use true here as underlying instance fetch is surrounded by try/catch
        };
        EppoJSClient.instance.setLogger(config.assignmentLogger);
        // default behavior is to use a LocalStorage-based assignment cache.
        // this can be overridden after initialization.
        EppoJSClient.instance.useCustomAssignmentCache(new local_storage_assignment_cache_1.LocalStorageAssignmentCache());
        EppoJSClient.instance.setConfigurationRequestParameters(requestConfiguration);
        await EppoJSClient.instance.fetchFlagConfigurations();
    }
    catch (error) {
        console.warn('Eppo SDK encountered an error initializing, assignment calls will return the default value and not be logged' +
            (config.pollAfterFailedInitialization
                ? ' until an experiment configuration is successfully retrieved'
                : ''));
        if ((_g = config.throwOnFailedInitialization) !== null && _g !== void 0 ? _g : true) {
            throw error;
        }
    }
    EppoJSClient.initialized = true;
    return EppoJSClient.instance;
}
exports.init = init;
/**
 * Used to access a singleton SDK client instance.
 * Use the method after calling init() to initialize the client.
 * @returns a singleton client instance
 * @public
 */
function getInstance() {
    return EppoJSClient.instance;
}
exports.getInstance = getInstance;
//# sourceMappingURL=index.js.map